<template>
  
  <div class="project-edit" style="" v-loading.fullscreen.lock="fullscreenLoading" >
    <div class="header">
      <div class="back" @click="$router.go(-1)">返回</div>
      <div class="title">新增/编辑角色菜单模板</div>
    </div>
    <div class="import-title">
      <span class="cost-title-list-txt">基础信息</span>
    </div>
    <div class="customer-information">
      <div class="cols">
        <div class="col-itms">
          <div class="title"><span>*</span>模板名称</div>
          <el-input size="small" class="w300" maxlength="15" placeholder="请输入" v-model="form.templateName"></el-input>
        </div>
        <div class="col-itms second">
          <div class="title"><span>*</span>有效状态</div>
          <el-radio-group class="w300 content-left" v-model="form.bizState">
            <el-radio label="Y">是</el-radio>
            <el-radio label="S">否</el-radio>
          </el-radio-group>
        </div>
        
      </div>

      <div class="cols">
        <div class="col-itms">
          <div class="title">
            <span>*</span>应用端</div>
          <el-select class="w300" size="small" @change="appSideChange" v-model="form.appSideGuid" placeholder="请选择">
            <el-option v-for="item in appsideList" :label="item.appSideName" :value="item.guid" :key="item.guid"> </el-option>
          </el-select>
        </div>
        <div class="col-itms second">
          <div class="title"><span></span>显示顺序</div>
          <el-input size="small" class="w300" maxlength="15" placeholder="请输入，不填写自动生成" v-model="form.orderNum"@input="form.orderNum = form.orderNum.replace(/[^\d]/g, '')"></el-input>
        </div>
        
      </div>
      <div class="cols">
        <div class="col-itms">
          <div class="title">
            <span></span>备注说明</div>
            <el-input size="small" class="w300" maxlength="30" placeholder="请输入" v-model="form.remark"></el-input>
        </div>
      </div>
     
    </div>
    <div class="menu-box" v-show="form.appSideGuid">
      <div class="import-title">
        <span class="cost-title-list-txt">菜单权限</span>
      </div>
      <div class="menu-information">
        <div class="empty">
          <el-button size="mini" plain @click="empty">清空重新选择</el-button>
        </div>
        <div class="menu-content">
          <div class="item item-left">
            <div class="title">应用产品</div>
            <div class="main">
              <el-input class="main-input" size="small" prefix-icon="el-icon-search" placeholder="请输入应用产品名称" v-model="form.advertSeq">
              </el-input>
              <el-checkbox-group class="main-checkbox" v-model="productGuidList">

                <el-checkbox
                  :class="activeProduct == product.guid ? 'checkbox-item bc-EBF6F7' : 'checkbox-item'"
                  @change="changePro(product)"
                  v-for="product in productList"
                  :key="product.guid"
                  :label="product.guid"
                  size="small"
                >
                  <span @click.prevent="changePro(product)" :class="activeProduct == product.guid ? 'check-txt fontC-4fa1a4 bc-EBF6F7' : 'check-txt'">{{
                    product.productName
                  }}</span>
                  <!-- <span :class="activeProduct==product.guid?'fontC-4fa1a4':''" @click.prevent="changePro(product)">{{product.productName}}</span> -->
                  <!-- {{ product.productName }} -->
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="item item-center">
            <div class="title">
              <span>菜单名称</span>
              <span>已选{{checkMenuGuids.length  }}个菜单</span>
              <!-- currentProduct.checkedKeys -->
            </div>
            <div class="main">
              <el-input class="main-input" size="small" prefix-icon="el-icon-search" placeholder="请输入菜单名称" v-model="form.menuName">
              </el-input>
              <el-tree
                v-if="isTreeShow"
                class="main-checkbox"
                :data="currentProduct.menus"
                show-checkbox
                node-key="guid"
                ref="tree"
                highlight-current
                :expand-on-click-node="false"
                :props="defaultProps"
                @check="handleNodeCilck"
                @node-click="handleNodeCilck1"
                :check-strictly="checkStrictly"
                :check-on-click-node="false"
                
              >
              <!-- :render-content="renderContent" 
                :filter-node-method="filterNode"
              -->
                <span class="custom-tree-node" slot-scope="{ node, data }" >
                  <span class="menu">{{ data.menuName }} 
                    <span v-if="data.remark">
                      <el-popover
                        v-if="showPopover(data)"
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="data.remark">
                        <span slot="reference" class="remark">({{ data.remark }}) </span>
                      </el-popover>
                      <span v-else class="remark">({{ data.remark }}) </span>
                    </span>
                  </span>
                  
                  
                    
                  
                </span>
                
              </el-tree>
            </div>
          </div>
          <div class="item item-right">
            <!-- <div class="title">按钮全选</div> -->
            <el-checkbox class="title" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">按钮全选</el-checkbox>
            <el-checkbox-group  class="main-checkbox" v-model="checkedBtns" @change="handleCheckedBtnsChange">
              <!-- <el-checkbox class="checkbox-item" v-for="btn in currentTreeNode.children" :label="btn" :key="btn.guid">{{btn.menuName}}</el-checkbox> -->
              <el-checkbox class="checkbox-item" v-for="btn in btnList" :label="btn" :key="btn.guid">{{btn.menuName}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    
    

    <div class="operte-btns">
      <div class="btn cancel" @click="$router.go(-1)">取消</div>

      <div v-if="$route.query.guid&&!$route.query.isCopy" class="btn submit" @click="upDateForm">提交</div>
      <div v-else class="btn submit" @click="submitForm">提交</div>
    </div>
  </div>
  <!-- 选择部门人员 start -->
  <!-- <ChoosePic ref="choosePicUrl"  @onSelect="onPicSelect"></ChoosePic> -->
    <!-- 选择部门人员 end -->

</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
// import ChoosePic from './components/choosePic.vue'
export default {
components: {
  // ChoosePic,
},
data() {
  return {
    fullscreenLoading: false,
    isTreeShow:true,
    isBtnShow:false,
    checkStrictly: false,
    form: {
      guid: '',
      platformGuid: '',
      appSideGuid: '',
      templateName: '',
      orderNum: '',
      bizState: 'Y',
      menuGuids: '',
      tenantGuid: '',
      remark:'',
      menuName:''
    },
    appsideList: [],
    productList: [],//左边应用产品的列表
    menuGuidList: [],//所选的菜单的guid
    ids: [],//详情里的菜单列表
    idsList:[],//详情里的按钮列表
    // roleDetailData: [],
    productGuidList:[],
    activeProduct:'',
    activeTreeNode:'',//选中的树节点
    currentTreeNode: {},
    currentProduct: {},//删除了按钮
    oldCurrentProduct: {},//没删除按钮
    defaultProps: {
      id: 'guid',
      label: 'menuName',
      children: 'children',
    },
    // cityOptions:['上海', '北京', '广州', '深圳'],
    checkAll: false,
    checkedBtns: [],
    btnList: [],
    allBtnList:[],
    isIndeterminate: false,
    checkMenuGuids:[]
  };
},
watch: {
  activeProduct(val) {
    
    this.currentProduct = this.productList.find((k) => k.guid === val) || {};
    // this.currentProduct.checkedKeys=[]
    this.oldCurrentProduct = this.productList.find((k) => k.guid === val) || {};
    // this.allBtnList=JSON.parse(JSON.stringify(this.currentProduct.menus));
    // this.operateDom()
    // this.oldCurrentProduct.menus.forEach((i)=>{
    //   if (i.children) {
    //     this.changeMenu(i.children)
    //   }
    // })
    console.log('==',this.currentProduct);
    console.log(this.$refs.tree.getCheckedKeys());
    // this.changeMenu(this.currentProduct.menus)
    this.refreshTree();
  },
  checkedBtns: {
    
    handler(newVal, oldVal) {
      // 数据发生变化时执行的操作
      console.log('639',newVal, oldVal);
      // this.matchAllBtns(newVal)
      // this.handleCheckedBtnsChange(newVal,1)
    },
    deep: true, // 是否深度监听
  },
  btnList: {
    
    handler(newVal, oldVal) {
      // 数据发生变化时执行的操作
      console.log('右侧按钮',newVal, oldVal);
      this.handleCheckedBtnsChange(newVal,1)
    },
    deep: true, // 是否深度监听
  },
  activeTreeNode(val) {
    // this.currentTreeNode = this.currentProduct.menus.find((k) => k.guid === val) || {};
    // console.log('445',this.currentTreeNode);
    // this.$refs.tree.filter('F');
    // this.operateDom()
    // this.refreshTree();
  },
  'form.appSideGuid'(val) {
    if(!val)return
    let self = this;
    self.appsideList.forEach(function (item) {
      // console.log(self.form.appSideGuid,item);
      if (self.form.appSideGuid == item.guid) {
        self.platformGuid = item.platformGuid;
        self.appSideName = item.appSideName;
      }
      console.log('566',self.platformGuid);
      
    });
    // self.page.pageIndex = 1;
    // self.getData(false);
  },
},
computed: {
  showCheckPayment() {
    // !上传付款通知书校验触发标识
    return this.form.bizTypeGuid === '1' ? true : false;
  },
  isDisabled() {
    // !查看模式
    return this.$route.query.operationMode === 'look';
  },
},
created() {
  // this.getDetail();
  // this.getAllProduct()
  this.getAppsideData()
  
  
},
methods: {
  showPopover(data){
    if(!data.remark)return false
    let str = data.menuName + data.remark
    if(str.length>23){
      return true
    }
  },
  matchAllBtns(newVal) {
    if(newVal.length>0){
      newVal.forEach((item)=>{
        this.allBtnList.forEach((k)=>{
          if(item.guid===k.guid){
            k.isChecked=item.isChecked;
          }
        })
        
      })
    }
    console.log('BtnList',this.btnList);
    
  },
  // 根据canEdit属性值判断是否渲染节点
  renderContent(h, { node, data, store }) {
    if (data.menuType!=='F') {
      return <span class='custom-tree-node'>{data.menuName}</span>;
    } else {
      // this.remove(node, data);
      this.operateDom()
      return <span class='custom_hide'>{data.menuName}
        <span class="remark-class" >'按钮'</span>
      </span>;
    }
    
  },
  // 删除节点数据方法
  remove(node, data) {
    const parent = node.parent;
    const children = parent.data.children || parent.data;
    const index = children.findIndex((d) => d.menuType === 	data.menuType);
    children.splice(index, 1);
  },
  filterNode(value, data) {
    // console.log('222',value, data);
    
      if (data.menuType!==value) {
        return true
      }else{
        return false
      }
      // return data.label.indexOf(value) !== -1;
    },
    // 操作dom结构，将最后一个层级隐藏
    operateDom(){
      this.$nextTick(() => {
      let dom = document.querySelectorAll('.custom_hide');
      dom.forEach((item, i) => {
        item.parentNode.parentNode.style.display = 'none';
      });
     }) 
    } ,
    // 按钮全选的事件checkAll
  handleCheckAllChange(val) {
    this.checkedBtns = val ? this.btnList : [];
    // this.checkedBtns = val ? this.currentTreeNode.children : [];
    this.isIndeterminate = false;
    if(!val){
      this.btnList.forEach(k=>{
        k.isChecked=false;
      })
    }else{
      this.btnList.forEach(k=>{
        k.isChecked=true;
      })
    }
    this.allBtnList.forEach((obj2) => {
      const matchObj = this.btnList.find((obj1) => obj1.guid === obj2.guid);
      if (matchObj) {
          obj2.isChecked = matchObj.isChecked||false;
      }
    });
  },
  // 按钮的change事件
  handleCheckedBtnsChange(value) {
    console.log('value',value,this.checkedBtns);
    //value点击菜单出来的时候是全部按钮，点击按钮复选框出来的是选中的按钮
    
    // let arr=value.filter(item=>item.isChecked)
    let arr=this.checkedBtns
    let checkedCount = arr.length;
    this.checkAll = checkedCount === this.btnList.length;
    if(this.btnList.length==0){
      this.checkAll=false
    }
    // this.checkAll = checkedCount === this.currentTreeNode.children.length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.btnList.length;
    // this.isIndeterminate = checkedCount > 0 && checkedCount < this.currentTreeNode.children.length;
   
    
    this.btnList.forEach(k=>{
      k.isChecked=false;
      if(arr.length>0){
        arr.forEach(item=>{
          if(item.guid===k.guid){
            k.isChecked=true;
          }
        })
      }
    })
    this.allBtnList.forEach((obj2) => {
      const matchObj = this.btnList.find((obj1) => obj1.guid === obj2.guid);
      if (matchObj) {
          obj2.isChecked = matchObj.isChecked;
      }
    });
    
    console.log('触发了按钮的change*',this.btnList,this.allBtnList.filter(item=>item.isChecked));
    
  },
  getDetail() {
    let self = this;
    let guid=this.$route.query.guid||''
    let isCopy=this.$route.query.isCopy||false
   
    if (!guid) return;
    self.productGuidList = [];
    // self.roleDetailData = [];
    self.ids=[]
    self.idsList = [];
    self.menuGuidList = [];
    self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/role-template/data/detail?guid=${guid}`).then((res) => {
      if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        let form = res.data.data;
        console.log('form',form);
        if(isCopy){
          form.templateName=''
          form.remark=''
          form.orderNum=''
        }
        this.form = form;
        this.getAllProduct()
        this.guid = form.guid;
        // self.activeProduct = res.data.data.productGuid ? res.data.data.productGuid[0] : '';
        self.productGuidList = res.data.data.productGuid ? res.data.data.productGuid : [];
        let children = res.data.data.children || [];
        children.forEach((i)=>{
          if (i.children) {
            self.getMenuGuidList(i.children)
          } else {
            // self.ids.push(i.guid);
            if(i.menuType=='F'){
              self.idsList.push(i)
              console.log('iiiii',i);
              
            }else{
              self.ids.push(i.guid);
            }
            
          }
        });
        self.menuGuidList = self.ids;
        console.log(JSON.stringify(self.menuGuidList),'menuGuidList');
        console.log( self.idsList,'idsList');
        
        
        self.isCheck = true; //重点：给数节点赋值之前 先设置为true
        self.$nextTick(() => {
          //因为我是根据数据id来判断选中所以使用setCheckedKeys，具体可以查看element官网api
          // self.$refs.tree.setCheckedKeys(self.menuGuidList); //给树节点赋值

          self.isCheck = false; //重点： 赋值完成后 设置为false
        });
        // setTimeout(()=>{

        // },2000)
        this.$nextTick(() => {//编辑
          this.getAllMenu();//统一放到getallproduct里面
        });
      } else {
        self.$message.error(res.data.msg);
      }
    });
  },
  //提交申请
  saveReq() {
    if (!this.checkForm()) {
      return;
    }
    let form = JSON.parse(JSON.stringify(this.form));
    console.log(form,777);
    
    let reqUrl;
    let method;
    let message;
    if (this.guid) {
      method='put'
      reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/role-template/data/update`;
      form.guid = this.guid;
      message='修改成功'
    } else {
      method='postJson'
      reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/role-template/data/add`;
      form.guid = null;
      message= '新增成功'
    }
    this.fullscreenLoading = true;
    this.api[method](reqUrl, form).then((res) => {
      this.fullscreenLoading = false;
      if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message({
          message: message,
          type: 'success',
        });
        this.$router.go(-1);
      } else {
        this.$message.error(res.data.msg);
      }
    });
  },
  submitForm(formName) {
    let self = this;
    if (!this.checkForm()) {
      return;
    }
    // self.$refs[formName].validate((valid) => {
      // if (valid) {
        const menuGuids = this.productList
          .reduce((total, next) => {
            const arr = (next.checkedKeys || [])
              .map((guid) => {
                const node = this.getNodeByGuid(guid, next.menus) || {};
                // if(node.menuType!=='F'){
                  return node.parentGuid ? node.parentGuid + '-' + node.guid : node.guid;
                // }
                
                // return node.parentGuids ? node.parentGuids.join('-') + '-' + node.guid : node.guid;  //parentGuids=[] ,包含所有父级guid
              })
              .join('-')
              .split('-');
            return [...total, ...arr];
          }, [])
          .filter((k) => k);
        const arrBtn=[]
        this.allBtnList.map(item=>{
           item.isChecked?arrBtn.push(item.guid):null;
        })
        let guidsArr=[]
        guidsArr=[...menuGuids,...arrBtn]
        let promise = {
          appSideGuid: self.form.appSideGuid,
          templateName: self.form.templateName,
          bizState: self.form.bizState,
          orderNum: self.form.orderNum,
          remark: self.form.remark,
          menuGuids: [...new Set([...guidsArr])],
        };
        console.log("新增",promise.menuGuids,arrBtn);
        
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/role-template/data/add`, promise).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            
            self.menuGuidList = [];
            self.$message.success('新增成功');
            this.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      // } 
    // });
  },
  upDateForm(formName) {
    let self = this;
    if (!this.checkForm()) {
      return;
    }
    const menuGuids = this.productList
      .reduce((total, next) => {
        const arr = (next.checkedKeys || [])
          .map((guid) => {
            const node = this.getNodeByGuid(guid, next.menus) || {};
            return node.parentGuid ? node.parentGuid + '-' + node.guid : node.guid;
            // return node.parentGuids ? node.parentGuids.join('-') + '-' + node.guid : node.guid;  //parentGuids=[] ,包含所有父级guid
          })
          .join('-')
          .split('-');
        return [...total, ...arr];
      }, [])
      .filter((k) => k);
    const arrBtn=[]
    this.allBtnList.map(item=>{
        item.isChecked?arrBtn.push(item.guid):null;
    })
    let guidsArr=[]
    guidsArr=[...menuGuids,...arrBtn]
    let promise = {
      guid: self.form.guid,
      appSideGuid: self.form.appSideGuid,
      templateName: self.form.templateName,
      bizState: self.form.bizState,
      orderNum: self.form.orderNum,
      remark: self.form.remark,
      menuGuids: [...new Set([...guidsArr])],
    };
    console.log("原来的",promise);
    self.fullscreenLoading = true;
    self.api.put(`/${serverConfig.msCommonAdminPlatformAuthService}/role-template/data/update`, promise).then((res) => {
      self.fullscreenLoading = false;
      if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        
        self.menuGuidList = [];
        self.$message.success('修改成功');
        this.$router.go(-1);
      } else {
        self.$message.error(res.data.msg);
      }
    });
      
  },
  getNodeByGuid(guid, tree) {
    let node;
    tree.forEach((k) => {
      if (k.guid === guid) {
        node = k;
      } else if (k.children) {
        k.children.forEach((j) => {
          if (j.guid === guid) {
            node = j;
          }else if(j.children){
            j.children.forEach(item=>{
              if(item.guid === guid){
                node = item
              }
            })
          }
        });
      }
    });
    return node;
  },
  // 选择应用端
  appSideChange(val) {
    console.log('88',val);
    this.productList = [];
    this.productGuidList = [];
    
    if (val) {
      this.getAllProduct()
    }
  },
  //清空内容
  empty() {
    this.activeProduct = '';
    this.productGuidList = [];
    
    this.currentProduct.checkedKeys = [];
    this.checkMenuGuids=[]
    this.currentProduct={}
    this.$refs.tree.setCheckedKeys([]);
    this.allBtnList.forEach(item=>{
      item.isChecked=null
    })
    this.btnList=[]
    console.log(159,this.$refs.tree.getCheckedKeys());
    // this.allMenuList = [];
    // this.$refs['ruleForm'].resetFields();
  },
  // 获取应用端列表
  getAppsideData(flg) {
    let self = this;
    self.loading = true;
    let promise = {
      guid: '',
      pageIndex: 1,
      appSideName: '',
      pageSize: 100,
      platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
      startTime: '',
      endTime: '',
    };
    self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`, promise).then((res) => {
      if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        self.loading = false;
        self.appsideList = res.data.data.records || [];
        // if(self.appsideList && self.appsideList.length > 0){
        //   self.appSideGuid = self.appsideList[0].guid;
        //   self.appSideName = self.appsideList[0].appSideName;
        //   self.platformGuid = self.appsideList[0].platformGuid;
        //   self.appsideList.forEach(i=>{
        //     i.tabName = i.appSideName;
        //   })
        // }
        // self.getAllProduct();
        // self.page.totalPage = res.data.data.totalPages;
        // self.page.totalRows = res.data.data.totalRows;
        
        this.getDetail()
        
      } else {
        self.$message.error(res.data.msg);
      }
    });
  },
  getAllProduct() {
    let self = this;
    this.productList = [];
    this.activeProduct = '';
    self.api
      .postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product/data/get`, {
        platformGuid: self.platformGuid,
        appSideGuid:self.form.appSideGuid,
        pageIndex: 1,
        pageSize: -1,
      })
      .then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data && res.data.data.records){
            self.productList = res.data.data.records||[] ;
            self.activeProduct = this.form.productGuid ? this.form.productGuid[0] : '';
            if(self.productList && self.productList.length > 0){
              self.productGuid = self.productList[0].guid;
            }
            console.log('111');
            
            // if(!self.$route.query.guid ){//新增
            //   console.log('222');
            //   self.getAllMenu();
            // }
            self.getAllMenu();
          }
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
  },
  getAllMenu() {
    let self = this;
    self.fullscreenLoading = true;
    setTimeout(() => {
      
    }, 3000);
    console.log('333',self.menuGuidList,this.productList);
    const AllPromises = (this.productList || []).map((product) => {
      let promise = {
        guid: '',
        parentGuid: '',
        platformGuid: self.platformGuid,
        productGuid: [product.guid],

      };
      return new Promise((resolve) => {
        self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get`, promise).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            
            product.menus = res.data.data;
            product.checkedKeys=[]
            product.allMenus=res.data.data;
            this.filterButton(product,product.menus)
            
            // console.log('*',product.menus);
            
            product.checkedKeys = self.menuGuidList.filter((k) => {
              const hasNodeByGuid = (guid, tree) => {
                // 判断树中有guid
                return tree.find((item) => {
                  return item.guid === guid || hasNodeByGuid(guid, item.children || []);
                });
              };
              return hasNodeByGuid(k, product.menus);
            });
            // self.menuGuidList = self.ids;
            // self.allMenuList.forEach((item) => {
            //   item.menuName = item.remark ? item.menuName + '（' + item.remark + '）': '（'+item.menuName + '）'; //菜单名+标签
            //   if (item.children) {
            //     item.children.forEach((oneData) => {
            //       oneData.menuName = oneData.remark ? oneData.menuName + '-' + oneData.remark : oneData.menuName ; //菜单名+标签
            //     });
            //   }
            // });
            resolve(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    });
    Promise.all(AllPromises).then((res) => {
      this.refreshTree();
      console.log('self.idsList',self.idsList);
      
      this.allBtnList.forEach(item=>{
        item.isChecked=false
        self.idsList.forEach(i=>{
          if(i.guid==item.guid){
            item.isChecked=true
          }
        })
      })
      self.fullscreenLoading = false;
    })
  },
  // 获取详情
  // getDataDetail(guid) {
  //   let self = this;
  //   if (guid == null || guid == '') {
  //     return;
  //   }
  //   self.ids = [];
  //   // self.checkStrictly = true
  //   self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get-detail?guid=` + guid).then((res) => {
  //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
  //       self.activeProduct = res.data.data.productGuid ? res.data.data.productGuid[0] : '';
  //       self.productGuidList = res.data.data.productGuid ? res.data.data.productGuid : [];
  //       let children = res.data.data.children || [];
  //       children.forEach((i)=>{
  //         if (i.children) {
            
  //           console.log('kkk');
            
  //           self.getMenuGuidList(i.children)
  //         } else {
  //           self.ids.push(i.guid);
  //         }
  //       });
  //       self.menuGuidList = self.ids;
  //       console.log(JSON.stringify(self.menuGuidList),'menuGuidList');
  //       self.isCheck = true; //重点：给数节点赋值之前 先设置为true
  //       self.$nextTick(() => {
  //         //因为我是根据数据id来判断选中所以使用setCheckedKeys，具体可以查看element官网api
  //         // self.$refs.tree.setCheckedKeys(self.menuGuidList); //给树节点赋值

  //         self.isCheck = false; //重点： 赋值完成后 设置为false
  //       });
  //       // setTimeout(()=>{

  //       // },2000)
  //       this.$nextTick(() => {
  //         self.getAllMenu();
  //       });
  //     } else {
  //       self.$message.error(res.data.msg);
  //     }
  //   });
  // },
  changePro(val) {
    this.activeProduct = val.guid;
  },
  //菜单勾选
  handleNodeCilck(node, checked) {
    let self = this;
    
    let flg=checked.checkedNodes.findIndex(i=>i.guid==node.guid)>-1
    console.log(flg,'点击节点复选框',node,checked);
    
    // return
    // this.isBtnShow=false
    // this.currentProduct.checkedKeys = this.$refs.tree.getCheckedKeys();
    // this.$refs.tree.filter('F');
    this.currentProduct.checkedKeys = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
    console.log('220',this.currentProduct.checkedKeys);
    this.checkMenuGuids=this.currentProduct.checkedKeys||[]
    this.checkedBtns=[]
    
    if(flg){//勾选
      this.btnList=[]
      // this.$refs.tree.setCurrentKey(node.guid)
      this.activeTreeNode=node.guid//点击的树节点的guid
      console.log('oo',node);
      // this.findbtnList(this.oldCurrentProduct.menus,this.activeTreeNode,node.pa)
      // this.currentTreeNode=node
      // console.log('220',node);
      // this.allBtnList.findIndex((i,index)=>{
      //   if(i.guid==node.guid){
      //     if(i.children&&i.children.length>0&&children[0].menuType=='F'){
      //       this.btnList=i.children
      //       this.currentTreeNode=node
      //       this.isBtnShow=true
      //     }else{
      //       this.btnList=[]
      //       this.currentTreeNode={}
      //     }
          
      //   }
      // })
      if(node.btnList&&node.btnList.length>0){
        // this.isBtnShow=true
        node.btnList.forEach((i)=>{
          // if(i.isChecked!=false){
            i.isChecked=true//菜单被勾选的时候，所有按钮被选中
          // }
          
        })
        this.checkedBtns=node.btnList.filter((i)=>{
          // return i.isChecked?i:null
          return i
        })
        this.btnList=node.btnList
      }else{
        // this.btnList=[]
      }
      // if(node.children&&node.children.length>0){
      //   node.children.forEach((i)=>{
      //     if(i.menuType=='F'){
      //       this.btnList.push(i)
      //     }
          
      //   })
      //   console.log('循环',this.btnList);
        
      //   this.currentTreeNode=node
      //   this.btnList.forEach((i)=>{
      //     if(!i.isChecked){
      //       i.isChecked=true
      //     }
          
      //   })
      //   this.checkedBtns=this.btnList.filter((i)=>{
      //     return i.isChecked?i:null
      //   })
      // }else{
      //   // 按钮全选
      //   this.btnList=[]
      //   // this.checkAll=false
      //   this.currentTreeNode={}
      // }
      // if(node.children[0].menuType=='F'){//按钮
      //   this.btnList=node.children
      //   // if(this.allBtnList&&this.allBtnList.length>0){

      //   // }
      //   this.currentTreeNode=node
      //   this.btnList.forEach((i)=>{
      //     if(!i.isChecked){
      //       i.isChecked=true
      //     }
          
      //   })
      //   this.checkedBtns=this.btnList.filter((i)=>{
      //     return i.isChecked?i:null
      //   })
      //   // this.isBtnShow=true
      // }else{
      //   this.btnList=[]
      //   this.currentTreeNode={}
      // }
      this.allBtnList.forEach((obj2) => {
        const matchObj = this.btnList.find((obj1) => obj1.guid === obj2.guid);
        if (matchObj) {
            obj2.isChecked = matchObj.isChecked||false;
        }
      });
      
    }else{//取消勾选
      this.btnList.forEach((i)=>{
        // delete i.isChecked;
        i.isChecked=false
          
      })
      this.allBtnList.forEach((obj2) => {
        const matchObj = this.btnList.find((obj1) => obj1.guid === obj2.guid);
        if (matchObj) {
            obj2.isChecked = matchObj.isChecked||false;
        }
      });
      this.btnList=[]
      this.currentTreeNode={}
    }
    
    console.log('///',this.btnList,this.checkedBtns);
    
    this.$forceUpdate()
    console.log('pp',node, checked);
    
    // self.checkStrictly = false
    // if(checked == false){
    //   self.currentProduct.checkedKeys.forEach((i,index)=>{
    //     if(node.guid == i){
    //       this.currentProduct.checkedKeys.splice(index,1)
    //     }
    //   })
    // }
    // this.$refs.tree.getHalfCheckedKeys() 选中子节点也选中父节点
    // let tree = this.$refs.tree;
    // let ss = tree.getCheckedKeys().concat(self.menuGuidList).concat(tree.getHalfCheckedKeys());
    // self.menuGuidList = [...new Set(ss)];
  },
  handleNodeCilck1(data,node, checked) {
    let self = this;
    // this.btnList=[]
    console.log('点击节点',data,node,checked);
    // let flg=checked.checkedNodes.findIndex(i=>i.guid==node.guid)>-1
    if(data.btnList&&data.btnList.length>0){
        // this.isBtnShow=true
        // data.btnList.forEach((i)=>{
        //   if(i.isChecked!=false){
        //     i.isChecked=true
        //   }
          
        // })
        // data.btnList.forEach((i)=>{
        //   this.allBtnList.forEach(k=>{
        //     if(k.guid==i.guid){
        //       i.isChecked=k.isChecked
        //     }else{
        //       if(i.isChecked!=false){
        //         i.isChecked=true
        //       }
        //     }
        //   })
          
        // })
        this.checkedBtns=data.btnList.filter((i)=>{
          return i.isChecked?i:null
        })
        this.btnList=data.btnList||[]
      }else{
        this.btnList=[]
      }
    
    
  },
  findbtnList(tree,guid){
    tree.forEach((i,index)=>{
      if(i.guid==guid){
        if(i.children&&i.children.length>0){
          i.children.forEach((j)=>{
            if(j.menuType=='F'){
              this.btnList=i.children
              // this.currentTreeNode=i
              // this.isBtnShow=true
            }else{
              this.findbtnList(i.children,guid)
            }
          })
        }else{
          this.btnList=[]
          // this.currentTreeNode={}
        }
      }
    })
  },

  refreshTree() {
    let checkedKeys = this.currentProduct.checkedKeys ? JSON.parse(JSON.stringify(this.currentProduct.checkedKeys)) :[]
    console.log('mmm',this.productList,this.currentProduct,checkedKeys);
    // this.checkMenuGuids=checkedKeys;
    // this.operateDom()
    // this.$refs.tree.filter('F');
    this.isTreeShow = false;
    this.$nextTick(() => {
      // 重新渲染菜单树节点
      this.isTreeShow = true;
      this.$nextTick(() => {
        // this.$refs.tree.filter('F');
        // //console.log(checkedKeys);
        // //console.log(this.currentProduct.menus,'currentProduct.menus');
        // this.$refs.tree && this.$refs.tree.setCheckedKeys(checkedKeys || []); // !这个钩子, 如果数组中包含父级id, 会默认勾选全部子集
        checkedKeys.forEach(item=>{
          this.$refs.tree && this.$refs.tree.setChecked(item,true,false);
        })
        this.currentProduct.checkedKeys = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
        console.log('220',this.currentProduct.checkedKeys);
        this.checkMenuGuids=this.currentProduct.checkedKeys||[]
      });
    });
  },
  filterButton(pro,tree) {
    // 递归
    pro.btnList=[]
    if(tree.length==0)return
    for (let i = 0; i < tree.length; i++) {
    
     if(tree[i].children){
      this.filterButton(tree[i],tree[i].children)
     }else{
      if(tree[i].menuType==='F'){
        pro.btnList.push(tree[i])
        tree.splice(i,1)
        i--
      }
     }
      
    }
    this.allBtnList=[...new Set([...this.allBtnList,...pro.btnList])]
    // tree.forEach((item,idx)=>{
    //   if(item.children){
    //     this.filterButton(item.children)
    //   }else{
    //     if(item.menuType==='F'){
    //       // tree.remove(item)
    //       // tree.splice(idx,1)
    //       // this.$delete(tree, idx);
    //       // console.log('f',idx);
    //       arr.push(idx)
    //     }
        
    //   }
    // })
    // console.log('7',arr);
    
   
  },
  changeMenu(tree) {
    // 递归
    tree.forEach(item=>{
      
      if(item.menuType==='F'){
        this.allBtnList.push(item)
        
      }else if (item.children){
          this.changeMenu(item.children)
        }
      
    })
  },
  // !递归拿到菜单配置的所有id
  getMenuGuidList(tree) {
    tree.forEach(item=>{
      
      // if(item.menuType!=='F'){
        if (this.ids.indexOf(item.guid) == -1) {
          // this.ids.push(item.guid)
          if(item.menuType==='F'){
            this.idsList.push(item)
          }else{
            this.ids.push(item.guid)
          }
        }
        if (item.children){
          this.getMenuGuidList(item.children)
        }else{
          // if(item.menuType=='F'){
          //     this.idsList.push(item)
          //     console.log('iiiiitemi',item);
              
          //   }else{
          //     this.ids.push(item.guid);
          //   }
        }
      // }else{
      //   return
      // }
      
    })
  },
  // getMenusNum(){
  //   this.checkMenuGuids = this.productList
  //         .reduce((total, next) => {
  //           const arr = (next.checkedKeys || [])
  //             .map((guid) => {
  //               const node = this.getNodeByGuid(guid, next.menus) || {};
  //               // if(node.menuType!=='F'){
  //                 return node.parentGuid ? node.parentGuid + '-' + node.guid : node.guid;
  //               // }
                
  //               // return node.parentGuids ? node.parentGuids.join('-') + '-' + node.guid : node.guid;  //parentGuids=[] ,包含所有父级guid
  //             })
  //             .join('-')
  //             .split('-');
  //           return [...total, ...arr];
  //         }, [])
  //         .filter((k) => k);
  // },

  checkForm() {
    if (!this.form.templateName) {
      this.$message.error('模板名称不能为空');
      return false;
    }
    if (!this.form.appSideGuid) {
      this.$message.error('应用端不能为空');
      return false;
    }
    if (!this.form.bizState) {
      this.$message.error('有效状态不能为空');
      return false;
    }
    
    return true;
  },
  
},
};
</script>

<style lang="less" scoped>
/deep/.el-checkbox__label {
width:calc(100% - 24px);
}
.check-txt {
width:100%;
display: block;
}
/deep/.el-input-number__decrease {
display: none;
}
/deep/.el-input-number__increase {
display: none;
}
/deep/ .el-input-number .el-input__inner {
text-align: left;
padding-left: 15px;
}
.iframe-sty {
width: 100%;
border: none;
height: 600px;
}

.flow {
background: #fff;
padding-left: 20px;
margin-top: 4px;
}

.pdt100 {
padding-bottom: 100px !important;
}

.header {
background: #fff;
margin: 4px 0;
font-size: 16px;
text-align: center;
line-height: 40px;
height: 40px;
display: flex;
align-items: center;
padding: 0 16px;
}

.header .back {
background: #ffffff;
border: 1px solid rgba(217, 217, 217, 1);
border-radius: 2px;
width: 60px;
height: 28px;
line-height: 28px;
font-size: 12px;
cursor: pointer;
}


.import-title {
text-align: left;
background: #fff;
padding: 10px 16px;
font-size: 16px;
position: relative;
}

.empty-tooltip {
background: #fff;
font-size: 16px;
padding: 25px 0;
}

.import-title.second {
margin-top: 4px;
}

.header .title {
text-align: center;
flex: 1;
}
.project-edit{
min-width:980px
}
.customer-information {
background: #fff;
padding-bottom: 15px;
}
.menu-box{
margin-top:2px;
background: #fff;
}
.menu-information {

padding:0 0 15px 75px ;
}
.menu-information .menu-content{
width: 880px;
display: flex;
.item{
  border: 1px solid rgba(217,217,217,1);
  .title{
    height:40px;
    text-align:left;
    font-size: 14px;
    color: #666666;
    line-height: 40px;
    padding:0 12px;
    border-bottom:1px solid rgba(217, 217, 217, 1);
    
  }
  .main{
    height:380px;
    .main-input{
      padding:8px;
      box-sizing: border-box;
    }
  }
}
.item-left{
  width:240px;
  border-right:none
}
.item-center{
  width:400px;
  border-right:none;
  .title{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    padding-right: 8px;
    max-width:88%;
    .menu{
      display: block;
      width: 100%;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .remark{
      // padding-left: 10px;
      color: #b2b2b2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .remark-class{
    color: #4FA1A4;
  }
}
.item-right{
  width:240px;
  .title{
    width: 100%;
    padding-left: 8px!important;
  }
  .main-checkbox{
    overflow:auto;
    height:380px
  }
}
}

.menu-information .empty{
background: #ffffff;
border-radius: 2px;
width: 88px;
height: 32px;
color: #212121;
line-height: 32px;
font-size: 12px;
cursor: pointer;
margin:8px 0
}
.main-checkbox{
overflow:auto;
height:332px
}
.checkbox-item{
width:100%;
height:32px;
line-height:32px;
text-align:left;
padding-left:8px;
box-sizing: border-box;
margin-right: 0;
}
.bc-EBF6F7{
background-color:#EBF6F7
}
//  .is-current {
//   background-color: #EBF6F7!important;
// }
/deep/ .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  // 设置颜色
  background-color: #EBF6F7; 
}
// /deep/ .el-tree-node:focus > .el-tree-node__content {
//   background-color: #EBF6F7;
// }

.customer-information .sub-title {
text-align: left;
font-size: 14px;
line-height: 28px;
padding: 10px 16px;
display: flex;
justify-content: space-between;
}

.sub-operate-add {
color: #4fa1a4;
margin-left: 14px;
cursor: pointer;
}

.sub-operate-add2 {
color: #4fa1a4;
font-size: 14px;
margin-left: 14px;
cursor: pointer;
position: absolute;
right: 35px;
top: 10px;
text-align: center;
}

.sub-operate-del {
font-size: 14px;
color: #4fa1a4;
cursor: pointer;
text-align: center;
margin: 0 20px;
}

.customer-information .cols {
background: #fff;
display: flex;
padding: 4px 16px;
padding-left: 20px;
}

.customer-information .col-itms {
display: flex;
align-items: baseline;
margin-left: 20px;
}

.customer-information .col-itms .title {
width: 120px;
text-align: right;
margin-right: 16px;
}

.customer-information .col-itms.second {
// margin-left: 170px;
}

.customer-information .col-itms .title span {
color: red;
.el-icon-question{
  color: #b2b2b2;
}
}

.import-new-wrap {
padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
text-align: left;
padding-left: 10px;
color: #666;
font-size: 12px;
}

.import-new-wrap .col-itms {
align-items: start;
}

.operte-btns {
background: #fff;
margin-top: 2px;
display: flex;
justify-content: center;
padding: 25px 0;
}



.operte-btns .btn {
padding: 5px 18px;
border: 1px solid rgba(217, 217, 217, 1);
border-radius: 2px;
cursor: pointer;
margin-right: 10px;
}

.operte-btns .btn.save {
border: 1px solid #4FA1A4;
color: #4FA1A4;
cursor: pointer;
}

.operte-btns .btn.submit {
border: 1px solid #4FA1A4;
background: #4FA1A4;
color: #fff;
cursor: pointer;
}
.file-operate {
display: flex;
}
.file-preview {
margin-left: 10px;
cursor: pointer;
text-decoration: underline;
cursor: pointer;
color: #4fa1a4;
}
.bank-content {
text-align: left;
background-color: #fff;
background-image: none;
border-radius: 4px;
border: 1px solid #dcdfe6;
box-sizing: border-box;
color: #606266;
outline: 0;
padding: 0 15px;
-webkit-transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
}
.bank-info {
color: #a7a7a7;
}

.content-left {
text-align: left;
}
.btn-upload {
width: 84px;
height: 28px;
padding: 0;
}

.file-img {
width: 100%;
height: 100%;
}

.icon-add {
float: left;
margin-left: 10px;
width: 250px;
height: 50px;
border: 1px dotted #ccc;
text-align: center;
line-height: 50px;
}
.icon-add2 {
float: left;
margin-left: 10px;
width: 100px;
height: 150px;
border: 1px dotted #ccc;
text-align: center;
line-height: 150px;
}

.img-close {
position: relative;
float: left;
width: 250px;
height: 50px;
margin-left: 20px;
background-color: #f5f5f5;
}
.img-close2 {
position: relative;
float: left;
width: 100px;
height: 150px;
margin-left: 20px;
background-color: #f5f5f5;
}

.close {
position: absolute;
right: 0;
top: 0;
width: 20px;
height: 20px;
}
</style>